import type { FaireProductEntity } from "../../entity_types/product";

export const p_vp3qbz66c9: FaireProductEntity = {
  token: "p_vp3qbz66c9",
  type: "product",
  name: "Candles - Vampire Blood Bleeding Set of 4 (10 in.)",
  brandToken: "b_89kf2nlsjr",
  brandName: "Designs by Deekay Inc.",
  imageUrl:
    "https://cdn.faire.com/fastly/b65b8dd9441ba9010747c34b55e68e33110d6da5119659154da8e8dba6c0f27d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e18e2598faadbe78703255c6ce7d1ea2799c1c1e45cf1045c018b213b2cd8406.jpeg",
    "https://cdn.faire.com/fastly/5f7e81349c49e2b3cd6cc552595a9bc910e366af458f7abb24f6f35fdf526f84.jpeg",
    "https://cdn.faire.com/fastly/53edc2d691e673d28c273ff4618e497540652c53d8532bc8317478562d6a3522.jpeg",
    "https://cdn.faire.com/fastly/5f20a3e957c1d75ac7b254ab18a690910ae31539527617bb6a7fc8f86162db1d.jpeg",
    "https://cdn.faire.com/fastly/f6a0c19b69f4e8253f578e0b3e288d2b25058ec25a6923a72e08363134eae4c2.jpeg",
  ],
  priceDollars: 5,
  description:
    "Candles - Vampire Blood Bleeding Set of 4 (10 in.)\n \n PRODUCT SPECS\n • Pack Size: Set of 4 candles\n • Size: 10-inch taper candles\n • Format: Bleeding candle set\n • Theme: Vampire Blood\n • Use: Suitable for gothic décor, seasonal displays, events, or ritual assortments\n \n RETAIL PERFORMANCE\n • High visual impact makes this a standout seasonal and novelty item\n • Strong fit for Halloween, gothic, and occult-themed collections\n • Set format supports gifting and premium display value\n • Easy cross-merchandise item near décor, incense, and altar accessories\n • Performs well in event, party, and themed boutique assortments",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:53:37.138Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
